<template>
	<div></div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...qmsComputed
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		openWindowReport(params) {
			// console.log('open확인 ', params);
			const frm = document.createElement('form');
			const reportUrl = params.ubiTarget;

			frm.setAttribute('name', 'rpForm');
			frm.setAttribute('action', reportUrl + 'ubi4/ubihtml.jsp');
			frm.setAttribute('method', 'post');
			frm.setAttribute('target', 'rpForm');

			const input = document.createElement('input');
			input.setAttribute('type', 'hidden');
			input.setAttribute('id', 'file');
			input.setAttribute('name', 'file');
			input.setAttribute('value', params.jrfName);

			frm.appendChild(input);

			const input2 = document.createElement('input');
			input2.setAttribute('type', 'hidden');
			input2.setAttribute('id', 'arg');
			input2.setAttribute('name', 'arg');
			input2.setAttribute('value', params.arg);

			frm.appendChild(input2);

			const davalue = params.streamdata;

			const input3 = document.createElement('input');
			input3.setAttribute('type', 'hidden');
			input3.setAttribute('id', 'streamdata');
			input3.setAttribute('name', 'streamdata');
			input3.setAttribute('value', davalue);

			frm.appendChild(input3);

			document.body.appendChild(frm);

			window.open(
				'about:blank',
				'rpForm',
				'width=' + 1024 + ',height=' + 768 + ',toolbar=0,menubar=0,location=0,status=0,scrollbars=1,resizable=0,left=0,top=0'
			);
			frm.submit();
		}
	}
};
</script>

<style></style>
